import * as React from 'react';
import { ButtonSize, ButtonVariant } from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useTranslations } from '@utils/useTranslations';
import { CustomRef, SectionId } from '../utils';
import { Container, ItemButton } from './TableOfContents.styles';

export interface IProps {
  items: CustomRef[];
  onItemClick: (item: CustomRef) => void;
  activeItem: SectionId;
}

export const TableOfContents = ({ items, onItemClick, activeItem }: IProps) => {
  const { translations } = useTranslations();

  if (items.length === 0) {
    return null;
  }

  return (
    <Container>
      {items.map(item => {
        if (item.display) {
          return (
            <ItemButton
              key={item.id}
              onClick={() => onItemClick(item)}
              size={ButtonSize.large}
              variant={ButtonVariant.textBlack}
              isActive={activeItem === item.id}
            >
              {i18n(`sale.navigation.${item.id}`, [], translations)}
            </ItemButton>
          );
        }
      })}
    </Container>
  );
};
